// frontend/src/pages/VerifyEmailPage.js
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../services/api';

function VerifyEmailPage() {
  const [message, setMessage] = useState('Verificando tu email...');
  const [isSuccess, setIsSuccess] = useState(false);
  const { token } = useParams(); // Obtenemos el token de la URL

  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        setMessage('Error: El enlace de verificación no es válido.');
        return;
      }

      try {
        // Hacemos la petición al backend con el token
        const response = await api.get(`/auth/verify-email/${token}`);
        setMessage(response.data.message || '¡Email verificado con éxito!');
        setIsSuccess(true);
      } catch (error) {
        setMessage(error.response?.data?.detail || 'Error al verificar el email. El enlace puede haber expirado o no ser válido.');
        setIsSuccess(false);
      }
    };

    verifyToken();
  }, [token]); // Se ejecuta cuando el token esté disponible

  return (
    <div className={`text-center mt-5 alert ${isSuccess ? 'alert-success' : 'alert-danger'}`}>
      <h2>Verificación de Email</h2>
      <p>{message}</p>
      {isSuccess && (
        <Link to="/login" className="btn btn-primary mt-3">
          Iniciar Sesión
        </Link>
      )}
    </div>
  );
}

export default VerifyEmailPage;